import { Product } from '../XV2';
import { useMemo } from 'react';
import uniq from 'lodash/uniq';
import flatten from 'lodash/flatten';

type UseProductCategoriesInput = {
    menuProducts: {
        product: Pick<Product, 'category' | 'subCategory'>;
    }[];
    activeCategory?: string;
};

export function useProductCategories(input: UseProductCategoriesInput) {
    const { menuProducts, activeCategory } = input;

    return useMemo(() => {
        const subCategoriesByCategory = {};

        for (const { product } of menuProducts) {
            const { category, subCategory } = product;

            if (category) {
                subCategoriesByCategory[category] = subCategoriesByCategory[category] || [];

                if (subCategory && !subCategoriesByCategory[category].includes(subCategory)) {
                    subCategoriesByCategory[category].push(subCategory);
                }
            }
        }

        return {
            categories: Object.keys(subCategoriesByCategory),
            subCategories: activeCategory
                ? subCategoriesByCategory[activeCategory] || []
                : uniq(flatten(Object.values(subCategoriesByCategory))),
        };
    }, [menuProducts, activeCategory]);
}
